/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AlignItemsBottom({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#AlignItemsBottom_svg__a)" clipRule="evenodd"><path d="M7.1 13V3A2.1 2.1 0 0 0 5 .9H3A2.1 2.1 0 0 0 .9 3v10c0 1.16.94 2.1 2.1 2.1h2A2.1 2.1 0 0 0 7.1 13ZM5.9 3v10a.9.9 0 0 1-.9.9H3a.9.9 0 0 1-.9-.9V3a.9.9 0 0 1 .9-.9h2a.9.9 0 0 1 .9.9ZM15.1 13V7A2.1 2.1 0 0 0 13 4.9h-2A2.1 2.1 0 0 0 8.9 7v6c0 1.16.94 2.1 2.1 2.1h2a2.1 2.1 0 0 0 2.1-2.1Zm-1.2-6v6a.9.9 0 0 1-.9.9h-2a.9.9 0 0 1-.9-.9V7a.9.9 0 0 1 .9-.9h2a.9.9 0 0 1 .9.9Z" /></g><defs><clipPath id="AlignItemsBottom_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;